import { CosmosClient } from "@azure/cosmos";
import { authProvider } from '../utils/authProvider';

export class GeneralUtil {
    
    public async GetList(searchParams: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColGetList?code=tWTvtBU3MMtHx2JPuCsrMreRe1humDZOctunsbV6DblgjfHdPQHEUg==';
        let API = API_URL + API_ENDPOINT ;

        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(searchParams)
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error:' + errorResponse.Message };
        }
    }

    public async Read(_id: string, table:string) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColRead?code=o/eUp/mJe0nA/1Rv7Tt9Ee2S4mJDiIaB1iTD7VZdayUX9EczgCkapg==';
        let API_PARAM = '&id=' + _id + '&table=' + table;
        let API = API_URL + API_ENDPOINT + API_PARAM;

        let response = await fetch(API,
            {
                method: "get",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                })
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            return { errors : 'Connection failed to API' };
        }
    }

    public async Create(_doc: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColCreate?code=2X9p2mH3ana2teoW5G9EaDkRFqP/3sXpkRVb3veVGTkD4bVOJaFi0A==';

        let API = API_URL + API_ENDPOINT;
        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_doc)
            }
        );

        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result; // Newly created document
            } else {
                return { errors : result.errors };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
        }
    }

    public async Update(_keyValues: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColSet?code=69FQRysek/CA9XeiaOtGjgx2dJTJ0hoaDgFifHKPDFudDXy/PJi0kA==';
        let API = API_URL + API_ENDPOINT;
        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_keyValues)
            }
        );

        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result; // Updated document
            } else {
                return { errors : result.errors, isConflict : result.isConflict };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
        }
    }

    public async Delete(_id: string, table:string) {
        let accountInfo = await authProvider.getAccountInfo();
        
        let _doc : any = {};
        _doc.id = _id;
        _doc.table = table;

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColDelete?code=IxPNLIz/HD1bIbM44wy3G2zlDok04ICoGtQdtpUzA3rG8avSbkcYDw==';
        let API = API_URL + API_ENDPOINT;
        let response = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(_doc)
            }
        );

        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result; // Updated document
            } else {
                return { errors : result.errors };
            }
        } else {
            // Error return from Azure Fucntion
            let errorResponse = await response.json();
            return { errors : 'Connection failed to API. Error :' + errorResponse.Message};
        }
    }

    public async DownloadList(searchParams: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralColDownload?code=H2C0ibQvC2w4BsGuvWRitWTHKYKaxk210NOw/bsfwOmv3ILRKUz4tA==';
        let API = API_URL + API_ENDPOINT ;

        let downloadUrl = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(searchParams)
            }
        ).then(response => response.blob()
        ).then(response => {
            //const downloadUrl = window.URL.createObjectURL(new Blob([response], {type : 'application/octet-stream'}));
            //console.log(downloadUrl + ".csv");
            //window.location.href = downloadUrl;

            //return downloadUrl;
            return window.URL.createObjectURL(new Blob([response], {type : 'application/octet-stream'}));
            //var a = document.createElement("a");
            //document.body.appendChild(a);
            // a.href = downloadUrl;
            // a.download = "myfileName.csv";
            // a.click();
            // window.URL.revokeObjectURL(downloadUrl);
            }
        );
        return downloadUrl;
        // if (response.ok) {
        //     let result = await response.json();
        //     if (result.isSuccess) {
        //         return result;
        //     } else {
        //         return { errors : result.errors };
        //     }
        // } else {
        //     // Error return from Azure Fucntion
        //     let errorResponse = await response.json();
        //     return { errors : 'Connection failed to API. Error:' + errorResponse.Message };
        // }
    }
    
    public async GetDashboardStatistic(searchParams: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/GetDashboardStatistics?code=YrrtYtm23iNiDop8jqQ8Xbg9h0L9whqiMyg6vOoEIyQyZBBXgovSCw==';
        let API = API_URL + API_ENDPOINT;

        let response = await fetch(API,
            {
                method: "get",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                })
            }
        );
        if (response.ok) {
            let result = await response.json();
            if (result.isSuccess) {
                return result;
            } else {
                return { errors : result.errors };
            }
        } else {
            return { errors : 'Connection failed to API' };
        }
    }

    public async DownloadUserList(searchParams: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralUserColDownload?code=JjFg16Rdm0coXKBeGTdy5lm2a41D7cSnaEnm/1sewBiZMqjG1mVw/w==';
        let API = API_URL + API_ENDPOINT ;

        let downloadUrl = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(searchParams)
            }
        ).then(response => response.blob()
        ).then(response => {
            return window.URL.createObjectURL(new Blob([response], {type : 'application/octet-stream'}));
            }
        );
        return downloadUrl;
    }

    public async DownloadUserCourseList(searchParams: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralUserCourseColDownload?code=1C5cg6C3GXySWhXaTaOwhjlMvEhSaszW6MVUOzGLHA7xa/GEwytPZQ==';
        let API = API_URL + API_ENDPOINT ;

        let downloadUrl = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(searchParams)
            }
        ).then(response => response.blob()
        ).then(response => {
            return window.URL.createObjectURL(new Blob([response], {type : 'application/octet-stream'}));
            }
        );
        return downloadUrl;
    }
    
    public async DownloadOrderList(searchParams: any) {
        let accountInfo = await authProvider.getAccountInfo();

        let API_URL = 'https://ultimatesprodevapi03.azurewebsites.net/api';
        let API_ENDPOINT = '/GeneralOrderDownload?code=k12HAWhGY7xCCGwYb2bWpaVLiXza5H7RyQL4BGzyEwxFNyPZHSvcXw==';
        let API = API_URL + API_ENDPOINT ;

        let downloadUrl = await fetch(API,
            {
                method: "post",
                headers: new Headers({
                    "Authorization": "Bearer " + accountInfo?.jwtIdToken,
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(searchParams)
            }
        ).then(response => response.blob()
        ).then(response => {
            return window.URL.createObjectURL(new Blob([response], {type : 'application/octet-stream'}));
            }
        );
        return downloadUrl;
    }
}